import React from "react";

const Dashboard = React.lazy(() => import("../containers/Dashboard"));
const UserManagement = React.lazy(() => import("../containers/UserManagement"));
const EventManagement = React.lazy(() =>
    import("../containers/EventManagement")
);
const ServiceManagement = React.lazy(() =>
    import("../containers/ServiceManagement")
);
const UserPurchased = React.lazy(() => import("../containers/UserPurchased"));
const UserProfile = React.lazy(() => import("../containers/UserProfile"));
const ServiceDetails = React.lazy(() => import("../containers/ServiceDetails"));
const AddService = React.lazy(() => import("../containers/AddService"));
const EditService = React.lazy(() => import("../containers/EditService"));
const TicketManagement = React.lazy(() =>
    import("../containers/TicketManagement")
);
const BookingManagement = React.lazy(() =>
    import("../containers/BookingManagement")
);
const BookingDetails = React.lazy(() => import("../containers/BookingDetails"));
const AddEvent = React.lazy(() => import("../containers/AddEvent"));
const EditEvent = React.lazy(() => import("../containers/EditEvent"));
const AddBooking = React.lazy(() => import("../containers/AddBooking"));
const EditBooking = React.lazy(() => import("../containers/EditBooking"));
const EditProfile = React.lazy(() => import("../containers/EditProfile"));
const AddBusiness = React.lazy(() =>
    import("../containers/BusinessManagement/AddBusiness")
);
const BusinessManagement = React.lazy(() =>
    import("../containers/BusinessManagement")
);
const AddBookingTable = React.lazy(() =>
    import("../containers/AddBookingTable")
);
const EditBookingTable = React.lazy(() =>
    import("../containers/EditBookingTable")
);
const BusinessDetail = React.lazy(() =>
    import("../containers/BusinessManagement/BusinessDetail")
);
const EditBusiness = React.lazy(() =>
    import("../containers/BusinessManagement/EditBusiness")
);
const SettingScreen = React.lazy(() => import("../containers/Setting"));
const StripeOauth = React.lazy(() =>
    import("../containers/Setting/Stripe/index")
);
const TicketDetails = React.lazy(()=>import("../containers/TicketManagement/TicketDetails"));
const EventDetails = React.lazy(() => import("../containers/EventDetails"));
const EventDetailsQrTickets = React.lazy(() =>
    import("../containers/EventDetails/EventAttendees/AttendeeTicketQrMapper")
);
const EventDetailCreatePurchase = React.lazy(() =>
    import("../containers/EventDetails/PurchasesTab/CreatePurchase")
);
const EventDetailCreatePurchaseOTP = React.lazy(() =>
    import("../containers/EventDetails/PurchasesTab/OtpVerification")
);

const ServiceOrderListing = React.lazy(() =>
    import("../containers/ServiceOrderListing")
);
const BookingOrderListing = React.lazy(() =>
    import("../containers/BookingOrderListing")
);
const MyEarning = React.lazy(() => import("../containers/VendorMyEarning"));

const PrivacyPolicy = React.lazy(() => import("../containers/PrivacyPolicy"));

const TermsConditions = React.lazy(() =>
    import("../containers/TermsConditions")
);
const ArtistDetails = React.lazy(() => import("../containers/ArtistDetails"));
const AddEditArtist = React.lazy(() => import("../containers/AddEditArtist"));
const VerifyTicket = React.lazy(() => import("../containers/VerifyTicket"));

const PayoutManagement = React.lazy(() =>
    import("../containers/PayoutManagement")
);

const LanguageManagement = React.lazy(() =>
    import("../containers/LanguageManagement")
);

const AddLanguage = React.lazy(() => import("../containers/AddLanguage"));

const CurrencyManagement = React.lazy(() =>
    import("../containers/CurrencyManagement")
);

const AddCurrency = React.lazy(() => import("../containers/AddCurrency"));
const ViewTransactions = React.lazy(() => import("../containers/Transactions"));

export {
    Dashboard,
    UserManagement,
    EventManagement,
    ServiceManagement,
    UserPurchased,
    UserProfile,
    ServiceDetails,
    AddService,
    EditService,
    TicketManagement,
    BookingManagement,
    EditEvent,
    BookingDetails,
    AddEvent,
    AddBooking,
    EditBooking,
    EditProfile,
    AddBusiness,
    BusinessManagement,
    AddBookingTable,
    EditBookingTable,
    BusinessDetail,
    EditBusiness,
    SettingScreen,
    StripeOauth,
    EventDetails,
    ServiceOrderListing,
    BookingOrderListing,
    MyEarning,
    PrivacyPolicy,
    TermsConditions,
    ArtistDetails,
    AddEditArtist,
    VerifyTicket,
    EventDetailsQrTickets,
    EventDetailCreatePurchase,
    EventDetailCreatePurchaseOTP,
    PayoutManagement,
    LanguageManagement,
    AddLanguage,
    CurrencyManagement,
    AddCurrency,
    ViewTransactions,
    TicketDetails}
